import { AppModule } from './app/app.module';
import { environment } from "./environments/environment";
import * as Sentry from "@sentry/angular";
import { platformBrowser } from '@angular/platform-browser';

if (environment.env_name !== 'local') {
  Sentry.init({
    dsn: "https://9e3055087307e3404555eec661fc1b90@o210964.ingest.us.sentry.io/4510668235210752",
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(
        {
          maskAllText: true, // Masks all text on the page
          blockAllMedia: true, // Blocks all media (images, videos, etc.) from being recorded
        }
      ),
    ],
    environment: environment.env_name,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    // tracePropagationTargets: ['https://dev.api.smartfunder.co.za/', 'https://api.nedbankeducation.co.za/',],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    profilesSampleRate: 0.5,
    debug: false, // Set to true to enable debug mode
  });
}



platformBrowser().bootstrapModule(AppModule);